import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/** Lets any component (e.g. Global Search's help panel) open the Keyboard Shortcuts dialog
 *  without a direct reference to it — they're mounted as siblings in the header, not
 *  parent/child, so a plain Subject is simpler than threading a ViewChild across them. */
@Injectable({ providedIn: 'root' })
export class KeyboardShortcutsService {
  private openSubject = new Subject<void>();
  open$ = this.openSubject.asObservable();

  requestOpen(): void {
    this.openSubject.next();
  }
}
